<template>
  <v-card v-if="tractVisitType" id="tract-visit-type-form">
    <v-card-title class="primary white--text">
      <v-row class="pa-2" justify="space-between">
        <span class="headline">
          {{ title }}
        </span>
        <BaseDialogActions hideRefresh hideFullscreen />
      </v-row>
    </v-card-title>
    <v-card-text class="text-right">
      <v-text-field
      class="pt-6"
      v-model="tractVisitType.name"
      :rules="[rules.required]"
      :label="$t('name')"
      color="black"
      :counter="maxNameLength"
      :maxlength="maxNameLength"
      ref="tractVisitTypeName"/>
      <v-textarea
      class="pb-6"
      v-model="tractVisitType.description"
      :label="$t('description')"
      color="black"
      rows="3"
      auto-grow
      :counter="maxDescriptionLength"
      :maxlength="maxDescriptionLength"/>
      <v-btn id="tract-visit-type-submit" color="primary" @click="submitClicked" :disabled="!canSubmit">
        {{ buttonText }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import fieldRules from '@/utils/rules.js'
import { StringConstants } from '@/utils/constants'

export default {
  name: 'TractVisitTypeForm',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  props: {
    propTractVisitType: {
      type: Object,
      required: false,
      default: undefined
    }
  },

  created () {
    if (this.propTractVisitType) {
      this.tractVisitType = cloneDeep(this.propTractVisitType)
      this.tractVisitType.description = this.tractVisitType.description ?? ''
    }
  },

  mounted () {
    setTimeout(_ => {
      this.$refs.tractVisitTypeName.focus()
      document.addEventListener('keyup', this.onKeyup)
    }, 0)
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.onKeyup)
  },

  computed: {
    editing () {
      return this.tractVisitType?.tractVisitTypeId
    },

    title () {
      return this.editing ? this.$t('editVisitType') : this.$t('createNewVisitType')
    },

    buttonText () {
      return this.editing ? this.$t('saveChanges') : this.$t('create')
    },

    canSubmit () {
      return this.tractVisitType.name.length > 0 && this.tractVisitType.name.length <= this.maxNameLength
    }
  },

  data: () => ({
    tractVisitType: {
      name: '',
      description: ''
    },
    maxNameLength: StringConstants.MediumStringLength,
    maxDescriptionLength: StringConstants.ExtraExtraLongStringLength,
    rules: fieldRules.rules
  }),

  methods: {
    ...mapActions('tract-visit-type', ['createTractVisitType', 'updateTractVisitType']),

    async submitClicked () {
      if (this.canSubmit) {
        this.tractVisitType.description = this.tractVisitType.description.replace(/\s+/g, ' ').trim()
        this.editing ? await this.updateTractVisitType(this.tractVisitType) : await this.createTractVisitType(this.tractVisitType)
        this.$emit('tract-visit-type-mutated')
      } else {
        this.setSnackError(this.$t('nameIsRequired'))
      }
    },

    onKeyup (e) {
      if (e.target?.tagName === 'TEXTAREA') return
      if (e.key.toLowerCase() === 'enter') {
        this.submitClicked()
      }
    }
  }
}
</script>
